const ProductBanner = {
  path: "",
  name: "",
  redirect: "/productbanner",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/productbanner",
      redirect: "/productbanner",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Product Banner",
      meta: {
        requiresAuth: true,
        activeUrl: "/productbanner",
        parent: "productbanner",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/productbanner/Index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/productbanner",
            parent: "productbanner",

            lv: 2,
          },
        },
        {
          path: "details/:id",
          name: "Product Banner Detail",
          component: () => import("@/views/pages/productbanner/Details"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/productbanner",
            parent: "productbanner",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};

export default ProductBanner;
